export type ImageExportFormat = "png" | "jpeg" | "svg";

export type RasterImageExportFormat = Exclude<ImageExportFormat, "svg">;

export const EXPORT_FORMAT_MIME: Record<RasterImageExportFormat, string> = {
    png: "image/png",
    jpeg: "image/jpeg",
};

export type ImageExportControlsProps = {
    format: ImageExportFormat;
    isExporting: boolean;
    onDownload: () => void;
    onClose: () => void;
};
